<template>
    <div class="org-manager" v-loading="loading">
        <Page title="组织架构管理">
            <div class="row-container">
                <div class="col-container" style="flex: 10">
                    <Card :no-border="false">
                        <template #header>
                            <div class="card-header">
                                <h4>租户列表</h4>
                                <div class="buttons">
                                    <el-button @click="showAdd" icon="el-icon-plus" size="mini" type="primary">新建</el-button>
                                </div>
                            </div>
                        </template>
                        <div style="padding: 5px">
                            <div
                                :class="{ 'active tenant-item': item.TenantID == tenantID, 'tenant-item': item.TenantID != tenantID }"
                                v-for="item of tenantData"
                                :key="item.TenantID"
                                @click="handleClick(item)"
                            >
                                <div>{{ item.TenantName }}</div>
                                <div v-if="item.TenantState == 1" class="el-button--success circle"></div>
                                <div v-else class="el-button--danger circle"></div>
                            </div>
                        </div>
                    </Card>
                </div>
                <div v-if="currentTenant" class="col-container" style="margin-left: 10px; flex: 14">
                    <Card :no-border="false">
                        <template #header>
                            <div class="card-header">
                                <h4>基础信息</h4>
                                <div class="buttons">
                                    <el-button @click="removeRow" icon="el-icon-delete" size="mini" type="danger">删除</el-button>
                                    <el-button @click="handleUpdate" icon="el-icon-edit-outline" size="mini" type="warning">修改</el-button>
                                </div>
                            </div>
                        </template>
                        <el-form size="mini" style="padding-left: 10px" :show-message="false" label-width="90px" label-position="left">
                            <el-row :gutter="10">
                                <el-col :span="8">
                                    <el-form-item label="名称:">
                                        <span>{{ currentTenant.TenantName }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="简称:">
                                        <span>{{ currentTenant.TenantNickName }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="状态:">
                                        <el-switch
                                            :before-change="confirmChange"
                                            @change="changeState"
                                            v-model="currentTenant.TenantState"
                                            active-color="#13ce66"
                                            inactive-color="#ff4949"
                                            :active-value="1"
                                            :inactive-value="0"
                                        ></el-switch>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="创建时间:">
                                        <span>{{ formatTime(currentTenant.CreatedTime, "YYYY-MM-DD") }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="过期时间:">
                                        <span>{{ currentTenant.ExpireDate }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label=" ">
                                        <el-button @click="showAuth" size="mini" type="text">修改授权</el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="管理员账号:">
                                        <span>{{ currentTenant.UserCode }}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </Card>
                    <Card style="margin-top: 10px">
                        <el-tabs type="border-card" v-model="name">
                            <el-tab-pane label="实体信息" name="EntityTree">
                                <div style="text-align: right; padding: 5px">
                                    <el-button @click="entityMgr" size="mini" type="primary">实体管理</el-button>
                                </div>
                                <el-tree
                                    class="my-tree"
                                    ref="tree"
                                    style="margin-top: 5px"
                                    :data="treeData"
                                    node-key="EntityID"
                                    default-expand-all
                                    highlight-current
                                    :expand-on-click-node="false"
                                >
                                    <template #default="{ data }">
                                        <div class="custom-tree-node">
                                            <span class="menu-icon icon-shop" v-if="data.EntityType == 1"></span>
                                            <span class="menu-icon icon-floor" v-if="data.EntityType == 2"></span>
                                            <span class="menu-icon icon-market" v-if="data.EntityType == 3"></span>
                                            <span class="menu-icon icon-org" v-if="data.EntityType == 101"></span>
                                            <span>{{ data.EntityName }}</span>
                                        </div>
                                    </template>
                                </el-tree>
                            </el-tab-pane>
                            <el-tab-pane label="功能权限" name="Private">
                                <div style="text-align: right; padding: 5px">
                                    <el-button @click="savePriv" size="mini" type="primary">保存</el-button>
                                </div>
                                <el-row :gutter="10">
                                    <el-col v-for="item in privList" :key="item" :span="6">
                                        <el-switch v-model="item.Enabled"></el-switch>
                                        <label style="padding-right: 20px">{{ item.PrivName }}</label>
                                    </el-col>
                                </el-row>
                            </el-tab-pane>
                            <el-tab-pane label="参数配置" name="Attrs">
                                <TenantAttrs :id="tenantID" ref="attrs" />
                            </el-tab-pane>
                        </el-tabs>
                    </Card>
                </div>
            </div>
        </Page>
        <EditTenant :data="editModel" @close="showEditDialog = false" v-if="showEditDialog" :show="showEditDialog" @save="saveTenant"></EditTenant>
        <SetAuthDate @close="showAuthDialog = false" v-if="showAuthDialog" :show="showAuthDialog" @save="setAuth"></SetAuthDate>
        <AddTenant @close="showAddDialog = false" v-if="showAddDialog" :show="showAddDialog" @save="addTenant"></AddTenant>
        <SetAuthDate @close="showAuthDialog = false" v-if="showAuthDialog" :show="showAuthDialog" @save="setAuth"></SetAuthDate>
    </div>
</template>
<script>
import EditTenant from "./components/EditTenant.vue";
import AddTenant from "./components/AddTenant.vue";
import SetAuthDate from "./components/SetAuthDate";
import dayjs from "dayjs";
import TenantAttrs from "./components/TenantAttrs.vue";

export default {
    name: "Tenant",
    components: { EditTenant, AddTenant, SetAuthDate, TenantAttrs },
    data() {
        return {
            showEditDialog: false,
            showAddDialog: false,
            showAuthDialog: false,
            showPrivDialog: false,
            editModel: null,
            authID: "",
            treeData: [],
            tenantData: [],
            tenantID: "",
            currentTenant: null,
            name: "EntityTree",
            counter: 0,
            privList: [],
        };
    },
    created() {
        this.getTenantData();
    },
    methods: {
        getTenantData(tenantId) {
            let params = {
                Key: "",
                PageIndex: 1,
                PageSize: 20000,
            };
            let __v = this;
            this.$ajax.post("/Platform/GetTenantList", params).then((res) => {
                if (res.Data) {
                    this.tenantData = [...res.Data];
                    if (tenantId) {
                        this.currentTenant = res.Data.find((item) => {
                            return item.TenantID === tenantId;
                        });
                        this.tenantID = tenantId;
                    } else {
                        this.currentTenant = { ...res.Data[0] };
                        this.tenantID = res.Data[0].TenantID;
                    }
                }
            });
        },
        handleClick(data) {
            this.tenantID = data.TenantID;
            this.currentTenant = { ...data };
            this.$refs.attrs.setID(this.tenantID);
        },
        getEntityData() {
            this.$ajax
                .post("/Tenant/GetEntityTree?tid=" + this.tenantID)
                .then((result) => {
                    if (result.Data) {
                        this.treeData = [...result.Data];
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        formatTime(time, format) {
            return dayjs(time).format(format);
        },
        showAdd() {
            this.editModel = null;
            this.showAddDialog = true;
        },
        handleUpdate() {
            this.editModel = { ...this.currentTenant };
            this.showEditDialog = true;
        },
        addTenant(data) {
            this.$ajax.post("Platform/AddTenant", data).then((res) => {
                this.$success("添加成功");
                this.showAddDialog = false;
                this.getTenantData();
            });
        },
        saveTenant(data) {
            this.$ajax.post("Platform/ChangeTenant", data).then((res) => {
                this.$success("保存成功");
                this.showEditDialog = false;
                this.getTenantData(this.tenantID);
            });
        },
        savePriv() {
            let arr = [];
            for (let i = 0; i < this.privList.length; i++) {
                if (this.privList[i].Enabled) {
                    arr.push(this.privList[i].PrivID);
                }
            }
            this.$ajax.post("Platform/ChangePrivs?id=" + this.tenantID, arr).then((res) => {
                this.$success("操作成功！");
                this.getTenantData();
                this.showPrivDialog = false;
            });
        },

        removeRow() {
            if (confirm("确定要删除吗？")) {
                this.$ajax.post("Platform/RemoveTenant?id=" + this.currentTenant.TenantID).then((res) => {
                    this.$success("操作成功！");
                    this.getTenantData();
                });
            }
        },
        confirmChange() {
            return new Promise((resolve, reject) => {
                this.$myConfirm()
                    .then(() => {
                        return resolve(true);
                    })
                    .catch(() => {
                        return reject(false);
                    });
            });
        },
        changeState(state) {
            if (state) {
                this.enableTenant(this.currentTenant);
            } else {
                this.disableTenant(this.currentTenant);
            }
        },
        disableTenant(item, index) {
            this.$ajax.post("Platform/DisabledTenant?id=" + item.TenantID, {}).then((res) => {
                this.$success("操作成功！");
                this.getTenantData(item.TenantID);
                return true;
            });
        },
        enableTenant(item) {
            this.$ajax.post("Platform/EnabledTenant?id=" + item.TenantID, {}).then((res) => {
                this.$success("操作成功！");
                this.getTenantData(item.TenantID);
                return true;
            });
        },
        showAuth(item, index) {
            this.showAuthDialog = true;
        },
        setAuth(data) {
            if (confirm("确定要为租户授权吗？")) {
                this.$ajax
                    .post("Platform/SetAuthDate", {
                        TenantID: this.tenantID,
                        ExpireDate: data.authDate,
                    })
                    .then((res) => {
                        this.$success("操作成功！");
                        this.getTenantData();
                        this.showAuthDialog = false;
                    });
            }
        },
        getPrivList(id) {
            this.$ajax.post("/Platform/GetTenantPrivs?id=" + id).then((res) => {
                if (res.Data) {
                    this.privList = res.Data;
                }
            });
        },
        getTenantInfo(id) {
            this.$ajax.post("/Platform/GetTenantInfo?id=" + id).then((res) => {
                if (res.Data) {
                    this.currentTenant = { ...this.currentTenant, ...res.Data };
                }
            });
        },
        entityMgr() {
            this.$router.push({ path: "/platform/entity", query: { tid: this.tenantID } });
        },
    },
    watch: {
        tenantID(newVal, oldVal) {
            this.getEntityData();
            this.getPrivList(newVal);
            this.getTenantInfo(newVal);
        },
    },
};
</script>

<style scoped>
.tenant-item {
    line-height: 30px;
    padding: 5px;
    vertical-align: middle;
    cursor: pointer;
}
.tenant-item div {
    display: inline-block;
}
.circle {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    margin-left: 10px;
    position: relative;
    top: 2px;
}
.col-container :deep(.ly-c-container) {
    height: auto;
}
.col-container {
    background-color: #f0f2f5;
}
.active {
    background-color: #f0f2f5;
}
.custom-tree-node .menu-icon {
    width: 20px;
    top: 2px;
    position: relative;
}
</style>
